export default __webpack_public_path__ + "static/media/include_6@3x.669b08d2.jpg";